import axios from 'axios';
import { View, parse, Warn } from 'vega';
import uniqid from 'uniqid';
import { BASE_URL } from '../api';

export async function render_chart(element, schema) {
    element.className = 'fr-deletable fr-disabled fr-draggable chart';
    element.setAttribute('contenteditable', 'false');
    element.setAttribute('draggable', 'true');
    element.innerHTML = `
        <div class="edit-btn fas fa-pen"> </div>
        <div class="move-btn fas fa-arrows-alt"> </div>
        <div class="graph"></div>
    `;

    const graph = element.querySelector('.graph');

    return new View(parse(schema), {
        container: graph,
        renderer: 'svg',
        logLevel: Warn,
        hover: true,
    }).runAsync();
}

export async function load_chart(element) {
    const params = JSON.parse(element.dataset.params);
    // TODO: Handle error
    const response = await axios.get(`${BASE_URL}/core/dummy_data/`, { params });
    return render_chart(element, response.data);
}


export function chart_html(params) {
    const data = JSON.stringify(params);
    const id = uniqid();
    const html = `
        <p></p>
        <div class="chart" data-id="${id}" data-params='${data}'></div>
        <p></p>
    `;

    return { id, html };
}

export function clean_charts(html) {
    const temp = document.createElement('div');
    temp.innerHTML = html;
    temp.querySelectorAll('.chart').forEach((element) => {
        element.className = 'chart';
        element.removeAttribute('contenteditable');
        element.removeAttribute('draggable');
        element.removeAttribute('data-id');
        element.innerHTML = '';
    });
    return temp.innerHTML;
}
